import Choices from "choices.js";
import Swiper from "swiper";

export default class Global {

    constructor() {
        this.initChoices();
        this.initReviews();
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }


    initReviews() {
        if(document.querySelectorAll('#reviewSlider') !== null){
            new Swiper('#reviewSlider .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop:true,
                autoplay: {
                    delay: 3500,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 2,
                    }
                }
            });
        }
    }
}
